import { CalendarDate, CalendarMinus01, CalendarPlus01 } from '@untitled-ui/icons-react/build/cjs';

export const WINDOW_TYPE = {
    OPEN: 'open',
    READY_TIME: 'ready_time',
    APPOINTMENT: 'appointment',
    DELIVERY_TIME: 'delivery_time',
};

export const DATE_TYPE = {
    OPEN: 'open',
    FIXED: 'fixed',
    FLEXIBLE: 'flexible',
};

export const PICKUP_DATE_TYPE_OPTIONS = [
    { label: 'Fixed date', value: 'fixed', icon: CalendarDate },
    { label: 'Flexible window', value: 'flexible', icon: CalendarPlus01 },
];

export const PICKUP_WINDOW_TYPE_OPTIONS = [
    { label: 'Business Hours', value: 'open' },
    { label: 'Ready by', value: 'ready_time' },
    { label: 'By appointment', value: 'appointment' },
];

export const DELIVERY_DATE_TYPE_OPTIONS = [
    { label: 'Open', value: 'open', icon: CalendarMinus01 },
    { label: 'Fixed date', value: 'fixed', icon: CalendarDate },
    { label: 'Flexible window', value: 'flexible', icon: CalendarPlus01 },
];

export const DELIVERY_WINDOW_TYPE_OPTIONS = [
    { label: 'Business Hours', value: 'open' },
    { label: 'Deliver by', value: 'delivery_time' },
    { label: 'By appointment', value: 'appointment' },
];
